// @ts-nocheck
import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Brand } from 'models/propTypes/tile';
import { getStartDate } from 'support/mediaTileHelper';
import { parseDate, formatAMPM } from 'common/support/dateHelper';

import { getUpcomingDay } from 'support/eventHelper';

import EventTitle from 'components/common/tile/EventTitle';
import AuthNWrapper from 'components/hoc/AuthNWrapper';
import { useNetworkName } from 'hooks/kitchenSink';
import MediaTile from './MediaTile';
import BrandedAuthTile from './BrandedAuthTile';

import styles from './EventTile.module.scss';

const messages = {
  upcoming: {
    id: 'tile.upcoming',
    description: 'TTS for upcoming',
  },
  ttsAt: {
    id: 'textToSpeechHelper.at',
    description: 'TTS for at',
  },
};

const EventTile = ({
  prefix,
  title,
  brand,
  authenticated,
  authTypes,
  startDate,
  ...rest
}) => {
  const intl = useIntl();

  const date = formatAMPM(intl, new Date(startDate));

  const titleTts = [prefix, title].join(', '); // Pause between prefix and title instead of read out the 'dot'
  const brandTts = useNetworkName(brand);

  const upcomingTimeTts = [
    intl.formatMessage(messages.upcoming),
    getUpcomingDay(intl, new Date(startDate)),
    intl.formatMessage(messages.ttsAt),
    date,
  ].join(' ');

  const tts = [upcomingTimeTts, titleTts, brandTts].join(', ');

  const renderTitle = hasFocus => (
    <EventTitle
      prefix={prefix}
      title={title}
      brand={brand}
      shouldScroll={hasFocus}
    />
  );

  const renderMetadata = hasFocus => {
    const dateString = getStartDate(intl, parseDate(startDate));
    return (
      dateString && (
        <React.Fragment>
          <BrandedAuthTile
            hasFocus={hasFocus}
            brand={brand}
            authenticated={authenticated}
            authTypes={authTypes}
          />
          <div className={styles.startDate} data-testid="upcoming-time">
            {dateString}
          </div>
        </React.Fragment>
      )
    );
  };

  return (
    <MediaTile
      renderTitle={renderTitle}
      renderMetadata={renderMetadata}
      isLive
      ttsText={tts}
      {...rest}
    />
  );
};

EventTile.propTypes = {
  prefix: PropTypes.string,
  title: PropTypes.string.isRequired,
  brand: Brand,
  startDate: PropTypes.number.isRequired,
  authenticated: PropTypes.bool,
  authTypes: PropTypes.arrayOf(PropTypes.string),
};

EventTile.defaultProps = {
  prefix: null,
  brand: null,
  authenticated: false,
  authTypes: [],
};

export default React.memo(AuthNWrapper(EventTile));
